if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        const self = this;
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else{
              // Enavi custom events to add addons to the cart
              document.addEventListener('enavi:cart:form-item:added', function (e) {
                const addonsAdded = e.detail
                if (!self.cart) {
                  window.location = window.routes.cart_url;
                  return;
                }
                if (!self.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: formData.get('id'),
                  cartData: response,
                });
                self.error = false;
                const quickAddModal = self.closest('quick-add-modal');
                if (quickAddModal) {
                  document.body.addEventListener(
                    'modalClosed',
                    () => {
                      setTimeout(() => {
                        self.cart.renderContents(response);
                      });
                    },
                    { once: true }
                  );
                  quickAddModal.hide(true);
                } else {
                  //If Addons were added to the cart, get cart contents and render
                  if(addonsAdded){
                    fetch(`${routes.cart_url}?sections=${self.cart.getSectionsToRender().map(section => section.id)}`).then((response) => response.json()).then((response) => {

                      for (const key in response) {
                        if (response.hasOwnProperty(key)) {
                          if( document.querySelector(key)){
                            const newElement = new DOMParser().parseFromString(response[key], 'text/html').querySelector('#CartDrawer').innerHTML;
                            document.querySelector('#CartDrawer').innerHTML  = newElement;
                          }

                          if(key == 'cart-icon-bubble') document.querySelector(`#${key}`).innerHTML  = new DOMParser().parseFromString(response[key], 'text/html').querySelector('#shopify-section-cart-icon-bubble').innerHTML;
                        }
                      }
                      setTimeout(() => {
                        self.cart.open();
                      });
                    })

                  }else{
                    self.cart.renderContents(response);
                  }
                }
              }, { once: true });
              //Add addons if exist
              document.dispatchEvent(new CustomEvent('enavi:addAddonsToCart'));
            } 
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

/*======================
    Enavi Custom JS
=======================*/

window.theme = window.theme || {};

theme.EnaviProductForm =(function(){
  
  function EnaviProductForm(container){
    if(container){
      this.init(container);
    }
  };

  EnaviProductForm.prototype = Object.assign({}, EnaviProductForm.prototype, {
    init: function(container){
      this.container = container;
      this.sectionID = this.container.dataset.section;
      this.form      = this.container.querySelector('#product-form-'+this.sectionID);
      this.addToCart = this.container.querySelector('#ProductSubmitButton-'+this.sectionID);
      this.variantSelectorEl = this.container.querySelector('variant-selects');
      this.mediaGallery = document.querySelector('product-modal');
      this.addToCart.type="button";
      this.allItems = [];
      if(this.form){
        this.addToCart.addEventListener('click', this.handleAtc.bind(this));
      }
      document.addEventListener('enavi:addAddonsToCart', this.addAlltemsToCart.bind(this));
      document.addEventListener('enavi:product-image:change', this.changeImageOnAddOnSelect.bind(this));
      this.selectAll('.enavi_addon').forEach(node => {
        node.addEventListener('change', this.changeImageOnAddOnSelect.bind(this))
      });

      // Add font selection event listeners
      const fontSelectors = this.selectAll('.font-selector');
      fontSelectors.forEach(node => {
        node.addEventListener('change', this.handleFontChange.bind(this));
      });

      // Set initial font if one is selected
      const selectedFont = this.select('.font-selector:checked');
      if (selectedFont) {
        this.handleFontChange({ target: selectedFont });
      }

      // Handle All Star engraving checkbox
      const allstarEngravingCheckbox = this.select('[data-allstar-engraving]');
      if (allstarEngravingCheckbox) {
        allstarEngravingCheckbox.addEventListener('change', this.handleAllStarEngravingChange.bind(this));
      }

      // Handle All Star blank clip checkbox
      const allstarBlankClipCheckbox = this.select('[data-allstar-blank-clip]');
      if (allstarBlankClipCheckbox) {
        allstarBlankClipCheckbox.addEventListener('change', this.handleAllStarBlankClipChange.bind(this));
      }

      // Handle All Star engraving text input
      const allstarEngravingText = this.select('#allstar-engraving-container .engraving_text');
      if (allstarEngravingText) {
        allstarEngravingText.addEventListener('input', this.handleAllStarEngravingTextChange.bind(this));
      }

      // Update the product image used when variant changes on initial page load
      this.initializeProductImage();
      

    },

    select: function(selector){
      return this.container.querySelector(selector);
    },

    selectAll: function(selector){
      return Array.prototype.slice.apply(this.container.querySelectorAll(selector));
    },

    handleAtc: function(){
      if(this.postDisabled){
        return;
      }
      this.postDisabled = true;
      this.prepareAndPostFormData();
    },

    prepareAndPostFormData: function(){
        this.allItems = this.getAllItems();
        
        if(!this.checkIfRequiredOptionsFilled(this.allItems)){
          this.postDisabled = false;
          return;
        }

        this.emitSubmitEvent();
    },

    getAllItems: function(){
      this.generateParentRefKey();

      const addonLineProps = this.selectAll('.addon-line-item-prop');

      addonLineProps.forEach(el => {
        el.remove();
      });

      const addonItems = this.getAddonItems();

      if(addonItems.length > 0){
        this.addParentLineItemProperties(addonItems);
      }
      return addonItems;
    },

    emitSubmitEvent: function(){     
      // Debug: Log all form inputs before submission
      console.log('Form inputs before submission:');
      this.selectAll('input[name^="properties["]').forEach(function(input) {
        console.log('Form property:', input.name, '=', input.value);
      });
      
      setTimeout((function(){
        this.addToCart.disabled = false;
        this.addToCart.setAttribute('type','submit');
        this.addToCart.click();
        this.addToCart.setAttribute('type','button');
        this.addToCart.classList.remove('btn--loading');
      }).bind(this),100);
    },
    
    addAlltemsToCart: function(){
      if (this.allItems.length === 0){
        document.dispatchEvent(new CustomEvent('enavi:cart:form-item:added'));
        this.postDisabled = false;
        return;
      }

      const data = { items: this.allItems };
      console.log('Adding items to cart:', data);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((response) => {
          console.log('Cart add response:', response);
          document.dispatchEvent(new CustomEvent('enavi:cart:form-item:added', { detail: response }));
          this.postDisabled = false;
        })
        .catch((error) => {
          console.error('Error occurred during the request:', error);
       });

      this.allItems = [];
    },

    generateParentRefKey: function () {
      var count = 2;
      var key='';
      while(count > 0){
        key = key + (Math.random() + 1).toString(36).substring(2);
        count--;
      }
      this.parentKey = key;
    },

    addParentLineItemProperties: function(addonItems){
      var lineItemProps = { _parent_product: true };
      addonItems.forEach(item => { 
        lineItemProps[item.title] = item.price;
        if (item.parentLineItem == "true"){
          Object.entries(item.properties).map((function(property){
            if (!property[0].startsWith('_')){
              lineItemProps[property[0]] = property[1];
              delete item.properties[property[0]];
            }
          }))   
        }
      });

      // Add free addon properties to the main product
      var freeAddonProps = this.getFreeAddonProperties();
      console.log('Free addon props to add:', freeAddonProps);
      Object.assign(lineItemProps, freeAddonProps);
      console.log('Final line item props:', lineItemProps);

      for( let propName in lineItemProps){
        console.log('Adding property to form:', propName, '=', lineItemProps[propName]);
        const propNode = this.select('[name="properties['+propName+']"]');
        if(propNode){
          propNode.value = lineItemProps[propName]; 
          console.log('Updated existing property node');
        }else{
          const newInput = document.createElement('input');
          newInput.type = 'hidden';
          newInput.className = 'addon-line-item-prop';
          newInput.name = 'properties[' + propName + ']';
          newInput.value = lineItemProps[propName];
          this.form.appendChild(newInput);
          console.log('Created new property input:', newInput.name, '=', newInput.value);
        }
      }
    },

    getAddonItems: function() {
      var addonItems = Array.prototype.slice.call(this.container.querySelectorAll('.enavi_addon:checked')).map((function(item){

        // Skip free addons - they don't create separate cart items
        if (item.hasAttribute('data-free-addon')) {
          return null;
        }

        var qtySelector = this.select('.quantity__input');
        var qty = 1;
        if (qtySelector){
          var qty = this.select('.quantity__input').value;
        }

        var addonItemData =  { 
          id: item.value, 
          quantity: qty,
          title: item.dataset.addonTitle,
          price: item.dataset.addonPrice,
          properties: {
            _child_product: true
          }
        };
        
        addonItemData.properties = Object.assign({}, addonItemData.properties,  this.getAddonLineItemProperties(item));

        if (item.hasAttribute('data-parent-line')){
          addonItemData.parentLineItem = 'true';
        };
        return addonItemData;
      }).bind(this));

      // Filter out null items (free addons)
      return addonItems.filter(item => item !== null);
    },

    getAddonLineItemProperties: function (item) {
      var properties = {};
      this.selectAll('.addon_property[data-variant-id="'+item.value +'"]').forEach(function (propertyNode) {
          if((propertyNode.type === "text" && propertyNode.value) || propertyNode.checked === true){
            properties[propertyNode.name] = propertyNode.value.replace(/"/g, '&quot;');
          }
      });
      return properties;
    },

    getFreeAddonProperties: function() {
      var properties = {};
      console.log('Looking for free addons...');
      var freeAddons = this.selectAll('.enavi_addon[data-free-addon]:checked');
      console.log('Found free addons:', freeAddons.length);
      
      freeAddons.forEach(function (freeAddon) {
        console.log('Processing free addon:', freeAddon.id, 'value:', freeAddon.value);
        
        // For free addons, we need to look for properties with the main product's variant ID
        // Get the main product variant ID from the variant selector
        var mainVariantId = null;
        if (this.variantSelectorEl && typeof this.variantSelectorEl.getCurrentVariant === 'function') {
          var currentVariant = this.variantSelectorEl.getCurrentVariant();
          if (currentVariant) {
            mainVariantId = currentVariant.id;
          }
        }
        
        if (mainVariantId) {
          console.log('Using main product variant ID:', mainVariantId);
          var propertyNodes = this.selectAll('.addon_property[data-variant-id="'+mainVariantId +'"]');
          console.log('Found property nodes for main product:', propertyNodes.length);
          
          propertyNodes.forEach(function (propertyNode) {
            console.log('Property node:', propertyNode.name, 'value:', propertyNode.value, 'type:', propertyNode.type, 'checked:', propertyNode.checked);
            if((propertyNode.type === "text" && propertyNode.value) || propertyNode.checked === true){
              properties[propertyNode.name] = propertyNode.value.replace(/"/g, '&quot;');
              console.log('Adding free addon property:', propertyNode.name, '=', propertyNode.value);
            }
          });
        } else {
          console.log('Could not get main product variant ID');
        }
      }.bind(this));
      console.log('Free addon properties:', properties);
      return properties;
    },

    changeImageOnAddOnSelect: function(event) {
      console.log('triggering changeImageOnAddOnSelect')
      if (!this.variantSelectorEl) {
        return
      }
      
      let variant;
      let eventTarget;

      if (event instanceof Event) {
        // This is a regular event call
        variant = event.detail?.variant;
        eventTarget = event.target;
      } else {
        // This is the initial call during initialization
        variant = event.variant;
        eventTarget = null;
      }

      if(!variant){
        variant = this.variantSelectorEl.getCurrentVariant();
      }
      
      // Safety check - if variant is still not available, return early
      if (!variant) {
        console.warn('No variant available for image selection');
        return;
      }
      
      // Build alt text dynamically based on available options (0-3 options)
      var targetVariantImageAltText = '';
      var optionParts = [];
      
      // Add available options to the array
      if (variant.option1 && variant.option1.trim() !== '') {
        optionParts.push(variant.option1);
      }
      if (variant.option2 && variant.option2.trim() !== '') {
        optionParts.push(variant.option2);
      }
      if (variant.option3 && variant.option3.trim() !== '') {
        optionParts.push(variant.option3);
      }
      
      // Join options with '+' separator
      targetVariantImageAltText = optionParts.join('+'); 
      
      // Debug logging
      console.log('Base alt text:', targetVariantImageAltText, 'Options:', optionParts);

      const bolt = this.select('#bolt-container input.enavi_addon:checked');
      if(bolt){
        // Handle case where there are no options (empty targetVariantImageAltText)
        if (targetVariantImageAltText === '') {
          targetVariantImageAltText = 'Bolt';
        } else {
          targetVariantImageAltText = targetVariantImageAltText + '+Bolt';
        }
        if (bolt.hasAttribute('data-addon-variant-title')) {
          if(this.select("[alt='"+targetVariantImageAltText+':'+bolt.getAttribute('data-addon-variant-title')+"']")){
            targetVariantImageAltText = targetVariantImageAltText + ':'+ bolt.getAttribute('data-addon-variant-title');
          }
        }  
      }

      if (eventTarget && eventTarget.tagName === 'INPUT' && eventTarget.hasAttribute('data-bolt-clip')) {
        const mainContainerForInput = eventTarget.closest('[data-main-container]')
        const noteContainer = mainContainerForInput?.querySelector('[data-note-container]');
        if (noteContainer) {
          noteContainer.classList.toggle('hidden', !eventTarget.checked)
        }
      }

      const clip = this.select('#clip-container input.enavi_addon:checked');
      if(clip){
        // Handle case where there are no options (empty targetVariantImageAltText)
        if (targetVariantImageAltText === '') {
          targetVariantImageAltText = 'Clip';
        } else {
          targetVariantImageAltText = targetVariantImageAltText + '+Clip';
        }
        if (clip.hasAttribute('data-addon-variant-title')) {
          if(this.select("[alt='"+targetVariantImageAltText+':'+clip.getAttribute('data-addon-variant-title')+"']")){
            targetVariantImageAltText = targetVariantImageAltText + ':'+ clip.getAttribute('data-addon-variant-title');
          }
        }
      }

      var copiedVariant = JSON.parse(JSON.stringify(variant));

      if(bolt || clip){
        console.log('Final alt text for image search:', targetVariantImageAltText);
        var selectedImage = this.mediaGallery.querySelector("[alt='"+targetVariantImageAltText+"']");
        if(selectedImage){
          copiedVariant.featured_media.id = parseInt(selectedImage.dataset.mediaId);
          console.log('Found matching image with ID:', selectedImage.dataset.mediaId);
        } else {
          console.log('No matching image found for alt text:', targetVariantImageAltText);
        }
      }

      const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.variantSelectorEl.dataset.section}"]`);

      //Updated function to handle case where the component is not loaded yet
      const updateMedia = () => {
        let allUpdated = true;
        mediaGalleries.forEach((mediaGallery) => {
          if (typeof mediaGallery.setActiveMedia === 'function') {
            mediaGallery.setActiveMedia(`${this.variantSelectorEl.dataset.section}-${copiedVariant.featured_media.id}`, true);
          } else {
            allUpdated = false;
          }
        });
        return allUpdated;
      };
    
      // Try to update immediately
      if (!updateMedia()) {
        // If not all galleries could be updated, retry after a short delay
        setTimeout(() => {
          if (!updateMedia()) {
            console.warn('Could not update all media galleries. setActiveMedia might not be available.');
          }
        }, 500); // Adjust this delay as needed
      }
  
      const modalContent = document.querySelector(`#ProductModal-${this.variantSelectorEl.dataset.section} .product-media-modal__content`);
      if (!modalContent) return;
      const newMediaModal = modalContent.querySelector(`[data-media-id="${copiedVariant.featured_media.id}"]`);
      modalContent.prepend(newMediaModal);
      
    },
    
    initializeProductImage: function() {
      if (this.variantSelectorEl && typeof this.variantSelectorEl.getCurrentVariant === 'function') {
        const currentVariant = this.variantSelectorEl.getCurrentVariant();
        if (currentVariant) {
          this.changeImageOnAddOnSelect({ variant: currentVariant });
        }
      }
    },

    checkIfRequiredOptionsFilled: function(allItems){
      emptyRequiredOptions  = [];
      allItems.forEach(item => {
        emptyRequiredOptions = emptyRequiredOptions.concat(this.selectAll('.option_required[type="text"][data-variant-id="'+item.id +'"]').filter(optionNode => {
          // Special handling for All Star engraving text when blank clip is selected
          if (optionNode.classList.contains('engraving_text') && optionNode.closest('#allstar-engraving-container')) {
            const blankClipCheckbox = this.select('[data-allstar-blank-clip]');
            if (blankClipCheckbox && blankClipCheckbox.checked) {
              // If blank clip is selected, text is not required
              optionNode.closest('.enavi_option').classList.remove('enavi_option_error');
              return false;
            }
          }
          
          if(!optionNode.value || !optionNode.value.trim()){
            optionNode.closest('.enavi_option').classList.add('enavi_option_error');
            return true;
          }
          optionNode.closest('.enavi_option').classList.remove('enavi_option_error');
          return false;
          
        }));        
      });
      return !emptyRequiredOptions.length; 
    },

    handleFontChange: function(event) {
      const fontInput = event.target;
      const engravingText = this.select('.engraving_text');
      
      if (!engravingText) {
        console.warn('Engraving text input not found');
        return;
      }

      // Map font values to actual font families
      const fontMap = {
        'Helvetica': 'Helvetica-Engraving',
        'Stanislav': 'Stanislav-Engraving',
        'Tungsten': 'Tungsten-Engraving',
        'Telegraphem': 'Telegraphem-Engraving',
        'All Star': 'VarsityTeam-Bold-Engraving'
      };

      const selectedFont = fontMap[fontInput.value];

      if (selectedFont) {
        engravingText.style.fontFamily = selectedFont;
      } else {
        console.warn('Font not found in map:', fontInput.value);
      }
    },

    handleAllStarEngravingChange: function(event) {
      const checkbox = event.target;
      const allstarEngravingOptions = this.select('#allstar-engraving-options');
      const allstarEngravingText = this.select('#allstar-engraving-container .engraving_text');
      const blankClipCheckbox = this.select('[data-allstar-blank-clip]');
      const blankClipOptions = this.select('#allstar-blank-clip-options');
      
      if (allstarEngravingOptions) {
        // Show/hide the engraving options based on checkbox state
        allstarEngravingOptions.style.display = checkbox.checked ? 'block' : 'none';
      }
      
      // If engraving is selected, uncheck the blank clip option
      if (checkbox.checked && blankClipCheckbox) {
        blankClipCheckbox.checked = false;
        if (blankClipOptions) {
          blankClipOptions.style.display = 'none';
        }
      }
      
      if (allstarEngravingText) {
        if (checkbox.checked) {
          // Set the Varsity Team Bold font when checkbox is checked
          allstarEngravingText.style.fontFamily = 'VarsityTeam-Bold-Engraving';
          // Also trigger font change event for the hidden font selector
          const hiddenFontSelector = this.select('#allstar-engraving-container .font-selector');
          if (hiddenFontSelector) {
            this.handleFontChange({ target: hiddenFontSelector });
          }
        } else {
          // Reset font when checkbox is unchecked
          allstarEngravingText.style.fontFamily = '';
        }
      }
    },

    handleAllStarBlankClipChange: function(event) {
      const blankClipCheckbox = event.target;
      const blankClipOptions = this.select('#allstar-blank-clip-options');
      const engravingCheckbox = this.select('[data-allstar-engraving]');
      const engravingOptions = this.select('#allstar-engraving-options');
      
      if (blankClipOptions) {
        // Show/hide the blank clip options based on checkbox state
        blankClipOptions.style.display = blankClipCheckbox.checked ? 'block' : 'none';
      }
      
      // If blank clip is selected, uncheck the engraving option
      if (blankClipCheckbox.checked && engravingCheckbox) {
        engravingCheckbox.checked = false;
        if (engravingOptions) {
          engravingOptions.style.display = 'none';
        }
      }
      
      // Add or remove the blank clip property from the main product form
      const blankClipProperty = this.select('input[name="properties[Clip Status]"]');
      if (blankClipCheckbox.checked) {
        if (!blankClipProperty) {
          const newInput = document.createElement('input');
          newInput.type = 'hidden';
          newInput.name = 'properties[Clip Status]';
          newInput.value = 'Blank';
          this.form.appendChild(newInput);
          console.log('Added blank clip property to main product form');
        }
      } else {
        if (blankClipProperty) {
          blankClipProperty.remove();
          console.log('Removed blank clip property from main product form');
        }
      }
      

    },

    handleAllStarEngravingTextChange: function(event) {
      const engravingText = event.target;
      const blankClipCheckbox = this.select('[data-allstar-blank-clip]');
      
      if (blankClipCheckbox && engravingText.value.trim() !== '') {
        // Uncheck blank clip option when text is entered
        blankClipCheckbox.checked = false;
        const blankClipOptions = this.select('#allstar-blank-clip-options');
        if (blankClipOptions) {
          blankClipOptions.style.display = 'none';
        }
        
        // Remove the blank clip property from the main product form
        const blankClipProperty = this.select('input[name="properties[Clip Status]"]');
        if (blankClipProperty) {
          blankClipProperty.remove();
          console.log('Removed blank clip property from main product form (text entered)');
        }
        

      }
    },



  });

  return EnaviProductForm;
})();

new theme.EnaviProductForm(document.querySelector('product-info'));